import Vue from 'vue';
import Component from 'vue-class-component';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import { mapGetters } from 'vuex';
import * as utils from '@/utils/utils';
import ConditionUpdate from '../ConditionUpdate/ConditionUpdate.vue';
import _ from 'lodash';
import * as SubUtils from '@/store/SubUtils';

/**
 * 未触发条件单
 */
@Component({
  components: {
    ConditionUpdate,
  },
  computed: {
    ...mapGetters({
      conditionNotTriggerList: 'Params/conditionNotTriggerList',
    }),
  },
})
export default class ConditionNotTrigger extends Vue {

  public conditionNotTriggerList: IOrderConditional[];
  public isShowUpdate = false;
  public currentSelect: IOrderConditional = {} as any;
  public typeArr: any = [];

  public get priceTickN() {
    return this.typeArr.priceTick;
  }

  public tableTitle: IFixedTableTitle[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'contract',
    },
    {
      text: '状态',
      width: '1.5rem',
      name: 'state',
    },
    {
      text: '条件',
      width: '1.5rem',
      name: 'condition',
    },
    {
      text: '下单',
      width: '3rem',
      name: 'order',
    },
    {
      text: '有效期',
      width: '2rem',
      name: 'effective',
    },
    {
      text: 'ID',
      width: '6rem',
      name: 'id',
    }];
  public get tableData() {
    const arr: any[] = [];
    for (const item of this.conditionNotTriggerList) {
      if ((item as any).orderType === 0) {
        arr.push({
          contract: item.targetId,
          state: ConditionData.getState(item),
          condition: ConditionData.getCondition(item),
          order: ConditionData.getOrder(item),
          effective: ConditionData.getText(ConditionData.validTime,
            item.validTime),
          id: item.id,
          stopText: item.state === front.con_order_run ? '暂停' : '启动',
        });
      }
    }
    return arr;
  }
  public destroyed() {
    // SubUtils.unSub('conditionNotTriggerList');
  }

  public deactivated() {
    // SubUtils.unSub('conditionNotTriggerList');
  }
  public handleStop(item: IOrderConditional) {
    console.log(item);
    const cond = new ctpfront_pb.OrderConditional();
    const data = _.find(this.conditionNotTriggerList, r => r.id === item.id)!;
    cond.setId(data.id);
    cond.setTargetId(data.targetId);
    cond.setPrice(data.price);
    cond.setConditionPriceType(front.con_last_price);
    cond.setOperationType(data.operationType);
    cond.setVolume(data.volume);
    cond.setDirection(data.direction);
    cond.setOffset(data.offset);
    cond.setValidTime(data.validTime);
    cond.setOrderPrice(data.orderPrice);
    cond.setOrderPriceType(data.orderPriceType);

    if (data.state === front.con_order_run) {
      cond.setState(front.con_order_stop);
    } else {
      cond.setState(front.con_order_run);
    }

    utils.indicator('正在处理...');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      utils.toast('操作成功');
      console.log(resolve);
    }, reject => {
      console.error(reject);
      utils.toast('失败: ' + reject.message);
      utils.closeIndicator();
    });
  }
  public async handleDel(item: IOrderConditional) {

    try {
      await utils.confirm('确认删除此条件单吗？', '删除？', '确定', '取消');
    } catch (e) {
      console.log(e);
      return;
    }

    utils.indicator('正在处理...');
    front.conditionOrderRemove('', '',
      item.id, resolve => {
        utils.closeIndicator();
        utils.toast('删除成功');
      }, reject => {
        utils.toast('失败: ' + reject.message);
        utils.closeIndicator();
      });
  }
  public handleUpdate(item: IOrderConditional) {
    // tslint:disable-next-line:no-string-literal
    this.typeArr = front['targetSet'][item.contract];
    this.$store.commit('priceTick/changePriceT', this.typeArr.priceTick);
    // this.typeArr = front.subTick(item.contract, 'trade-detail');
    this.currentSelect = _.find(this.conditionNotTriggerList,
      r => r.id === item.id)!;
    this.isShowUpdate = true;
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionNotTrigger/ConditionNotTrigger.ts